import i from "./highrise1423.mjs";
function o(t) {
  if (typeof t == "string" || i(t))
    return t;
  var r = t + "";
  return r == "0" && 1 / t == -1 / 0 ? "-0" : r;
}
export {
  o as default
};
